var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer"},[_c('div',{staticClass:"offer-box"},[_c('p',{staticClass:"d-inline center"},[_vm._v(" free shiping today")]),_c('v-icon',{staticClass:"d-inline",attrs:{"id":"ship"}},[_vm._v(" mdi-moped ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }